import { render, staticRenderFns } from "./UniversityTable.vue?vue&type=template&id=c655b7ee&scoped=true&"
import script from "./UniversityTable.vue?vue&type=script&lang=js&"
export * from "./UniversityTable.vue?vue&type=script&lang=js&"
import style0 from "./UniversityTable.vue?vue&type=style&index=0&id=c655b7ee&scoped=scss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c655b7ee",
  null
  
)

export default component.exports